import { IconTag } from "@tabler/icons-react";

import { Badge, type BadgeProps, Flex, Tooltip } from "~/ui";

const defaultIcon = <IconTag size={16} />;
const defaultColor = "gray";
const defaultSize = "md";

interface IconComponentProps {
  icon: string;
}
const IconComponent = (props: IconComponentProps) => {
  switch (props.icon) {
    default:
      return defaultIcon;
  }
};

export interface TagDisplayProps {
  label: string;
  color?: string | null;
  icon?: string | null;
  size?: BadgeProps["size"] | null;
  isDeletable?: boolean;
}
export const TagDisplay = (props: TagDisplayProps) => {
  const Icon = () => (
    <Flex>
      <IconComponent icon={props.icon ?? ""} />
    </Flex>
  );

  const badge = (
    <Badge
      color={props.color ?? defaultColor}
      leftSection={<Icon />}
      maw={200}
      size={props.size ?? defaultSize}
      variant="light"
      style={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis" }}
    >
      {props.label}
    </Badge>
  );

  return (
    <Tooltip label={props.label} withArrow openDelay={400}>
      {badge}
    </Tooltip>
  );
};
